import { User, DeletedUser } from '~/hooks/useUserLookup';

const isDeletedUser = (user: User): user is DeletedUser =>
  user.__typename === 'DeletedUser';

export default isDeletedUser;
